function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./View", "react/jsx-runtime"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./View"), require("react/jsx-runtime"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.View, global.jsxRuntime);
    global.asyncViewComponent = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes, _react, _View, _jsxRuntime) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.asyncViewComponent = asyncViewComponent;
  _propTypes = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  var ErrorBoundary = /*#__PURE__*/function (_Component) {
    _inherits(ErrorBoundary, _Component);

    var _super = _createSuper(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this;

      _classCallCheck(this, ErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        error: null,
        hasError: false
      };
      return _this;
    }

    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {// do something if you need to.
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          var ErrorComponent = this.props.errorComponent;
          return ErrorComponent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ErrorComponent, {
            error: this.state.error
          }) : null;
        } else {
          return this.props.children;
        }
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        return {
          error: error,
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(_react.Component);

  ErrorBoundary.propTypes = {
    errorComponent: _propTypes.default.func,
    children: _propTypes.default.node.isRequired
  };

  function asyncViewComponent(_ref) {
    var resolve = _ref.resolve,
        componentProps = _ref.componentProps,
        _ref$LoadingComponent = _ref.LoadingComponent,
        LoadingComponent = _ref$LoadingComponent === void 0 ? asyncViewComponent.LoadingComponent : _ref$LoadingComponent,
        _ref$ErrorComponent = _ref.ErrorComponent,
        ErrorComponent = _ref$ErrorComponent === void 0 ? asyncViewComponent.ErrorComponent : _ref$ErrorComponent,
        _ref$WrapperComponent = _ref.WrapperComponent,
        WrapperComponent = _ref$WrapperComponent === void 0 ? _View.View : _ref$WrapperComponent;
    var Component = /*#__PURE__*/(0, _react.lazy)(resolve);
    return function (props) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(WrapperComponent, _objectSpread(_objectSpread({}, componentProps), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ErrorBoundary, {
          errorComponent: ErrorComponent || null,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
            fallback: LoadingComponent ? LoadingComponent(componentProps) : null,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread({}, props))
          })
        })
      }));
    };
  }
});